import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { FormControlProps } from '@mui/material/FormControl/FormControl';
import { SelectProps } from '@mui/material/Select/Select';
import { v4 as uuidV4 } from 'uuid';

import { getLinkedInputLabelAndSelectProps } from '~/components/GenericForm/EnumSelect/data';
import { Enum } from '~/data/enums';

type PropsType = SelectProps & {
  FormControlProps?: FormControlProps;
  enumOptions?: Enum[];
  getOptionLabel?: (option: Enum) => string;
  isOptionDisabled?: (option: Enum) => boolean;
  includeEmptyOption?: boolean;
  helperText?: string;
  shrink?: boolean;
};
export const EnumSelect = (props: PropsType) => {
  const {
    FormControlProps,
    enumOptions,
    getOptionLabel,
    includeEmptyOption,
    helperText,
    children,
    shrink,
    isOptionDisabled,
    ...selectProps
  } = props;

  const { label, required, id } = selectProps;
  const linkedComponentProps = getLinkedInputLabelAndSelectProps({
    label,
    selectId: id || uuidV4(),
    required,
    shrink,
  });

  const resolvedSelectProps: SelectProps = {
    ...selectProps,
    ...linkedComponentProps.selectProps,
  };

  return (
    <FormControl {...FormControlProps}>
      <InputLabel {...linkedComponentProps.inputLabelProps} />
      <Select {...resolvedSelectProps}>
        {children}
        {!required && !!includeEmptyOption && (
          <MenuItem value={''} key={'empty'}>
            -
          </MenuItem>
        )}
        {!!enumOptions &&
          enumOptions.map((option) => (
            <MenuItem
              value={option.code}
              key={option.code}
              disabled={
                !!isOptionDisabled ? isOptionDisabled(option) : undefined
              }
            >
              {!!getOptionLabel ? getOptionLabel(option) : option.name}
            </MenuItem>
          ))}
      </Select>
      {helperText && (
        <FormHelperText error={resolvedSelectProps.error}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
